import { render, staticRenderFns } from "./TableReportCommissionOfMonths.vue?vue&type=template&id=31b1cb73"
import script from "./TableReportCommissionOfMonths.vue?vue&type=script&lang=js"
export * from "./TableReportCommissionOfMonths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports